import React from 'react'

import Header from '../Components/Header';
import Left_Intro from '../Components/Left_Intro';
import Right_Pannel from '../Components/Right_Pannel';
import Skill_Main from '../Components/Skill_main';

function Skill() {
    return (
      <>
          <title>Skills | Akshat Srivastava</title>

          <meta
            name="description"
            content="Explore the skills of Akshat Srivastava, showcasing expertise in software development, UI/UX design, and innovative solutions."
          />

          <meta
            name="keywords"
            content="Akshat Srivastava Skills, Software Development, UI/UX Design, Portfolio, React, Java, Python, Figma"
          />

          <link
            rel="canonical"
            href="https://akshat-srivastava-navy.vercel.app/skills"
          />

          {/* Open Graph */}
          <meta property="og:title" content="Skills | Akshat Srivastava" />
          <meta
            property="og:description"
            content="Explore the skills of Akshat Srivastava, showcasing expertise in software development, UI/UX design, and innovative solutions."
          />
          <meta property="og:type" content="website" />

        <div className="bg-default">
          <Header />
          <div className="md:flex md:px-28">
            <Left_Intro />
            <div className="flex-1 w-full overflow-hidden px-4 py-6">
              <Skill_Main />
            </div>
            <div className="hidden sticky md:block">
              <Right_Pannel />
            </div>
          </div>

          <div className="block md:hidden">
            <Right_Pannel />
          </div>
        </div>
      </>
    );
}

export default Skill